export default __webpack_public_path__ + "tag585d5b.svg";